import{jsx as e}from"react/jsx-runtime";import{LoaderCircle as f}from"@edikk-edikk/shared";const i=({isLoading:r,content:o,color:t="#fff"})=>r?e(f,{sizeXs:!0,borderColor:t}):o;export{i as ButtonContentWithLoader};
